import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { NewPageHeader } from '@sorare/core/src/components/navigation/NewPageHeader';
import { scoutingCenter } from '@sorare/core/src/lib/glossary';

const Wrapper = styled(Vertical)`
  min-height: calc(100vh - var(--current-stack-height));
`;

const ScoutingCenterLayout = () => {
  return (
    <Wrapper>
      <NewPageHeader text={scoutingCenter.scoutingCenter} disableBackBrowser />
      <Outlet />
    </Wrapper>
  );
};

export default ScoutingCenterLayout;
